// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DocumentModel } from './documentModel.js';
import type { DocumentsV1GeneratePdfFromHtmlSaveSuccessResponse } from './documentsV1GeneratePdfFromHtmlSaveSuccessResponse.js';
import type { IEntlibFailureResponse } from './iEntlibFailureResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DocumentsV1GeneratePdfFromHtmlSaveResponse {
    'success': boolean;
    'messages': Array<string>;

    static discriminator = "success" as const;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DocumentsV1GeneratePdfFromHtmlSaveResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return DocumentsV1GeneratePdfFromHtmlSaveResponse.attributeTypeMap;
    }
}
